/**
 * @file UI toggle for default 4x6 vs receipt print format.
 */

import React from 'react';
import { usePrintFormatPreference } from '../hooks/usePrintFormatPreference';
import {
  PRINT_FORMAT_4X6,
  PRINT_FORMAT_RECEIPT,
  PRINT_FORMAT_LABELS,
} from '../utils/printFormatPreference';

function PrintFormatToggle({ style }) {
  const { format, setPrintFormat } = usePrintFormatPreference();

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
        ...style,
      }}
    >
      <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Default print:</span>
      <div
        role="group"
        aria-label="Default print format"
        style={{
          display: 'inline-flex',
          border: '1px solid #ccc',
          borderRadius: '6px',
          overflow: 'hidden',
        }}
      >
        {[PRINT_FORMAT_4X6, PRINT_FORMAT_RECEIPT].map((value) => {
          const active = format === value;
          return (
            <button
              key={value}
              type="button"
              onClick={() => setPrintFormat(value)}
              className="btn"
              style={{
                padding: '6px 12px',
                fontSize: '13px',
                borderRadius: 0,
                border: 'none',
                backgroundColor: active ? '#007bff' : '#f8f9fa',
                color: active ? '#fff' : '#333',
                fontWeight: active ? '600' : '400',
              }}
              aria-pressed={active}
            >
              {PRINT_FORMAT_LABELS[value]}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default PrintFormatToggle;
